import {
  BuildingOffice2Icon,
  CalendarDaysIcon,
  ChartBarIcon,
  CubeIcon,
  DocumentTextIcon,
  HomeIcon,
  InboxArrowDownIcon,
  MegaphoneIcon,
  QuestionMarkCircleIcon,
  TagIcon,
  UsersIcon,
} from "@heroicons/react/24/solid";
import { IconNames } from "components/Icon/Icon";
import SupportIcon from "components/Icon/icons/SupportIcon";
import { TbGauge } from "react-icons/tb";

export type IMenuChild = {
  id: string;
  label: string;
  Icon: any;
  disableBoard?: boolean;
  add?: boolean;
  addRightType?: string;
  addRightKey?: string;
  addRightKeyJoker?: string[];
  useWordingPlural?: boolean;
  requiredRights?: string[];
  requiredOrgFeature?: string;
};
export type IMenuGroup = {
  label: string;
  children: IMenuChild[];
  icon: IconNames;
  useWordingPlural?: boolean;
  ignoreGroup?: boolean;
};

export type IMenuConf = Record<string, IMenuGroup>;

/** ******************************** Items ********************************** */
const dashboardItem: IMenuChild = {
  id: "./",
  label: "board",
  Icon: HomeIcon,
  disableBoard: true,
};

const eventsItem: IMenuChild = {
  id: "events",
  label: "events",
  Icon: CalendarDaysIcon,
};

const documentsItem: IMenuChild = {
  id: "documents",
  label: "documents",
  Icon: DocumentTextIcon,
};

const productsItem: IMenuChild = {
  id: "products",
  label: "products",
  Icon: CubeIcon,
};

const smartReportsItem: IMenuChild = {
  id: "smart-reports",
  label: "smartReports",
  Icon: ChartBarIcon,
};

const eventTypesItem: IMenuChild = {
  id: "event-types",
  label: "eventTypes",
  Icon: TagIcon,
};

const tagsItem: IMenuChild = {
  id: "tags",
  label: "tags",
  Icon: TagIcon,
};

const plansItem: IMenuChild = {
  id: "plans",
  label: "plans",
  Icon: TbGauge,
};

const contactRequestsItem: IMenuChild = {
  id: "contact-requests",
  label: "contactRequests",
  Icon: InboxArrowDownIcon,
};

const faqItem: IMenuChild = {
  id: "faq",
  label: "faq",
  Icon: QuestionMarkCircleIcon,
};

const newsItem: IMenuChild = {
  id: "news",
  label: "news",
  Icon: MegaphoneIcon,
};

const organizationsItem: IMenuChild = {
  id: "organizations",
  label: "organizations",
  Icon: BuildingOffice2Icon,
};

const administratorsItem: IMenuChild = {
  id: "administrators",
  label: "administrators",
  Icon: UsersIcon,
  requiredRights: ["canManageUsers", "canAccessAdminPanel"],
};

const supportItem: IMenuChild = {
  id: "support",
  label: "support",
  Icon: SupportIcon,
};

/** ******************************** Sections ******************************* */

const homeSection: IMenuConf = {
  home: {
    label: "",
    icon: "MdOutlineChecklist",
    ignoreGroup: true,
    children: [dashboardItem],
  },
};

const contentSection: IMenuConf = {
  content: {
    label: "content",
    icon: "MdOutlineChecklist",
    children: [
      eventsItem,
      documentsItem,
      productsItem,
      smartReportsItem,
      eventTypesItem,
      tagsItem,
      plansItem,
    ],
  },
};

const communitySection: IMenuConf = {
  community: {
    label: "community",
    icon: "MdOutlineChecklist",
    children: [contactRequestsItem, faqItem, newsItem],
  },
};

const superadminSection: IMenuConf = {
  admin: {
    label: "admin",
    icon: "VcsSettings",
    children: [organizationsItem, administratorsItem],
  },
};

const helpSection: IMenuConf = {
  aide: {
    label: "help",
    icon: "IoColorPaletteOutline",
    children: [supportItem],
  },
};

/** **********************************  Menus by roles ************************** */
export const getSuperadminMenu = (): IMenuConf => ({
  ...homeSection,
  ...contentSection,
  ...communitySection,
  ...superadminSection,
  ...helpSection,
});

export const getManagerMenu = (): IMenuConf => ({
  ...homeSection,
  ...contentSection,
  ...communitySection,
  ...helpSection,
});

export const getSuperadminFilteredMenu = (): IMenuConf => ({
  ...helpSection,
});
